type AppEnv = 'development' | 'local' | 'live' | 'staging' | 'test'

declare global {
  // eslint-disable-next-line ts/consistent-type-definitions
  interface Window {
    __APP_CONFIG__?: Record<string, string>
  }
}

// Reads a value injected at container start via index.html.
// Returns undefined when the placeholder is still intact (dev server, missing var),
// which lets callers fall back to import.meta.env.* for local dev.
function readRuntimeConfig(key: string): string | undefined {
  const value = typeof window !== 'undefined' ? window.__APP_CONFIG__?.[key] : undefined
  if (!value || value.startsWith('__')) return undefined
  return value
}

const appEnv = (
  readRuntimeConfig('APP_ENV') ?? import.meta.env.VITE_APP_ENV ?? 'local'
) as AppEnv

// Map app env to the deployment.environment label the API also publishes,
// so dashboards can filter both with the same value.
const deploymentEnvByApp: Record<AppEnv, string> = {
  development: 'dev',
  local: 'local',
  live: 'live',
  staging: 'staging',
  test: 'test',
}

export const env = {
  api: {
    url: readRuntimeConfig('API_URL') ?? import.meta.env.VITE_API_URL,
  },
  app: {
    env: appEnv,
    version: readRuntimeConfig('APP_VERSION') ?? import.meta.env.VITE_APP_VERSION ?? 'local',
  },
  otel: {
    service: {
      name: readRuntimeConfig('OTEL_SERVICE_NAME') ?? import.meta.env.VITE_OTEL_SERVICE_NAME ?? 'studeva/web',
      version: readRuntimeConfig('OTEL_SERVICE_VERSION') ?? import.meta.env.VITE_OTEL_SERVICE_VERSION ?? '1.0.0',
      namespace: 'studeva',
    },
    deploymentEnvironment: deploymentEnvByApp[appEnv] ?? 'local',
    endpoint: readRuntimeConfig('OTEL_EXPORTER_OTLP_ENDPOINT') ?? import.meta.env.VITE_OTEL_EXPORTER_OTLP_ENDPOINT ?? '/otlp',
  },
}
